import React from "react";
import { TrackingCaseDocumentFieldValueEditTemplate } from "themes/application/tracking-case/pages";
import { observer } from "mobx-react";
import { TrackingCaseDocumentFieldValueEditViewStore } from "application/tracking-case/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new TrackingCaseDocumentFieldValueEditViewStore(rootStore), "trackingCaseDocumentFieldValueEditViewStore")
@observer
class TrackingCaseDocumentFieldValueEdit extends React.Component {
	render() {
		return <TrackingCaseDocumentFieldValueEditTemplate {...this.props} />;
	}
}

export default TrackingCaseDocumentFieldValueEdit;